<div class="container-fluid">
  @if (isLoading) {
  <div class="loader-box">
    <div class="loader-16"></div>
  </div>
  }@if (!isLoading) {
  <form
    class="theme-form mega-form"
    [formGroup]="cwEditForm"
    (ngSubmit)="onSubmit()"
  >
    <div class="row">
      <div class="col-12 d-xl-none">
        <div class="alert alert-warning" role="alert">
          <i class="far fa-clock"></i> Horario de atención de 06:00 a 00:00. Las
          solicitudes se procesaran dentro de este horario.
        </div>
        <div class="alert alert-warning" role="alert">
          <i class="fas fa-exclamation-circle"></i> Los campos con * son
          obligatorios
        </div>
      </div>
      <div class="col-sm-12 col-xl-7 content-left order-2 order-xl-1">
        <div class="alert alert-warning d-none d-xl-block" role="alert">
          <i class="far fa-clock"></i> Horario de atención de 06:00 a 00:00. Las
          solicitudes se procesaran dentro de este horario.
        </div>
        <div class="alert alert-warning d-none d-xl-block" role="alert">
          <i class="fas fa-exclamation-circle"></i> Los campos con * son
          obligatorios
        </div>
        <div class="row">
          <div class="col-sm-6">
            <label>Tipo Transaccion *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="tipo_transaccion"
              required=""
              readonly
              placeholder="Tipo transacción"
              [value]="transactionLabel"
            />
          </div>
          <div class="col-sm-6">
            <label>Monto *</label>
            <input
              #montoInput
              type="text"
              class="form-control custom-input"
              id="monto"
              required=""
              readonly
              placeholder="Monto"
              formControlName="monto"
            />
          </div>
        </div>
        <div class="row mt-3">
          @if
          (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
          ALLOWED_TYPES_FOR_BANK) && cwEditForm.get('tipo_transaccion')?.value
          !== TRANSACTION_TYPE_VALUES.FINANCIAL ) {
          <div class="col-sm-6 mt-1">
            <label>Banco Cliente *</label>
            <ng-select
              [items]="allClientBankData"
              bindLabel="label"
              bindValue="value"
              formControlName="id_banco"
              placeholder="Selecciona un banco"
              (scrollToEnd)="onScrollToEnd()"
              (search)="onSearch($event.term)"
              (open)="onSearch('')"
              (change)="isInterbankTransaction ? onBankSelected($event) : null"
            >
            </ng-select>
            @if (cwEditForm.controls.id_banco!.touched &&
            cwEditForm.controls.id_banco.errors?.required) {
            <div class="text-danger font-error mt-2">El Banco es requerido</div>
            }
          </div>
          }@else if (cwEditForm.get('tipo_transaccion')?.value ===
          TRANSACTION_TYPE_VALUES.FINANCIAL) {
          <div class="col-XL-12 mt-1">
            <label>Banco Cliente *</label>
            <ng-select
              [items]="allClientBankData"
              bindLabel="label"
              bindValue="value"
              formControlName="id_banco"
              placeholder="Selecciona un banco"
              (scrollToEnd)="onScrollToEnd()"
              (search)="onSearch($event.term)"
              (open)="onSearch('')"
              (change)="isInterbankTransaction ? onBankSelected($event) : null"
            >
            </ng-select>
            @if (cwEditForm.controls.id_banco!.touched &&
            cwEditForm.controls.id_banco.errors?.required) {
            <div class="text-danger font-error mt-2">El Banco es requerido</div>
            }
          </div>
          } @if (tipo_usuario !== userType.MASTER) { @if
          (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
          ALLOWED_TYPES_FOR_AGENT_READONLY)) {
          <div class="col-sm-6">
            <label>Agente *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="id_agente"
              required
              readonly
              placeholder="Agente"
              [value]="agent"
            />
          </div>
          } @if
          (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
          ALLOWED_TYPES_FOR_AGENT_READONLY_SPECIAL)) {
          <div class="col-xl-12">
            <label>Agente *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="id_agente"
              required
              readonly
              placeholder="Agente"
              [value]="agent"
            />
          </div>
          } } @else { @if(cwData.id_jugador === null || cwData.id_jugador ===
          DEFAULT_VALUE){ @if
          (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
          ALLOWED_TYPES_FOR_AGENT_READONLY)){
          <div class="col-sm-6">
            <label>Agente *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="id_agente"
              required
              readonly
              placeholder="Agente"
              [value]="agent"
            />
          </div>
          } @if
          (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
          ALLOWED_TYPES_FOR_AGENT_READONLY_SPECIAL)) {
          <div class="col-xl-12">
            <label>Agente *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="id_agente"
              required
              readonly
              placeholder="Agente"
              [value]="agent"
            />
          </div>
          } }@else{ @if
          (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
          ALLOWED_TYPES_FOR_PLAYER_READONLY)) {
          <div class="col-sm-6">
            <label>Jugador *</label>
            <span
              *ngIf="isBackofficePlayer"
              ngbTooltip="Jugador Backoffice"
              tooltipClass="custom-tooltip"
              class="mt-1 ms-2"
            >
              <img
                src="../../../../../../../assets/images/logo/logo-icon-zg.png"
                alt=""
                width="15"
                height="15"
              />
            </span>
            <input
              type="text"
              class="form-control custom-input"
              id="id_jugador"
              required
              readonly
              placeholder="Jugador"
              [value]="player"
            />
          </div>
          } @if
          (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
          ALLOWED_TYPES_FOR_PLAYER_READONLY_SPECIAL)) {
          <div class="col-xl-12">
            <label>Jugador *</label>
            <span
              *ngIf="isBackofficePlayer"
              ngbTooltip="Jugador Backoffice"
              tooltipClass="custom-tooltip"
              class="mt-1 ms-2"
            >
              <img
                src="../../../../../../../assets/images/logo/logo-icon-zg.png"
                alt=""
                width="15"
                height="15"
              />
            </span>
            <input
              type="text"
              class="form-control custom-input"
              id="id_jugador"
              required
              readonly
              placeholder="Jugador"
              [value]="player"
            />
          </div>
          } } }
        </div>
        <div class="row mt-3">
          @if (tipo_usuario !== userType.AGENT_LEVEL_ONE) { @if
          (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
          ALLOWED_TYPES_FOR_HOLDER_BY_EDIT)) {
          <div class="col-sm-12">
            <label>Titular *</label>
            <ng-select
              [items]="allHoldersData"
              [bindLabel]="'label'"
              [bindValue]="'value'"
              formControlName="id_titular"
              placeholder="Selecciona un titular"
              (scrollToEnd)="onScrollToEnd()"
              (search)="onSearch($event.term)"
              (clear)="onSearch('')"
              (open)="onSearch('')"
              [disabled]="!isTitularEnabled()"
            ></ng-select>
            @if (cwEditForm.controls.id_titular!.touched &&
            cwEditForm.controls.id_titular.errors?.required) {
            <div class="text-danger font-error mt-2">
              El Titular es requerido
            </div>
            }
          </div>
          } }
        </div>
        @if (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
        ALLOWED_TYPES_FOR_RECEIPT)) {
        <div class="row mt-3">
          <div class="col-sm-6">
            <label>Comprobante cliente *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="comprobante"
              (keyup)="validatorsReciptImg()"
              required=""
              placeholder="Comprobante"
              formControlName="comprobante"
            />
            @if (cwEditForm.controls.comprobante!.touched &&
            cwEditForm.controls.comprobante.errors?.required) {
            <div class="text-danger font-error mt-2">
              El comprobante es requerido
            </div>
            } @if (reciptError) {
            <div class="text-danger font-error mt-2">
              El comprobante ingresado no coincide con el comprobante de la
              imagen.
            </div>
            }
          </div>
          <div class="col-sm-6">
            <label>Transferencia Interbancaria</label>
            <ng-select
              [items]="optionsInterbankTransfer$ | async"
              bindLabel="label"
              bindValue="value"
              required=""
              formControlName="transferencia_interbancaria"
              placeholder="Selecciona una opción"
              (change)="isInterbankTransaction ? onBankSelected($event) : null"
            >
            </ng-select>
            @if (cwEditForm.controls.transferencia_interbancaria!.touched &&
            cwEditForm.controls.transferencia_interbancaria.errors?.required) {
            <div class="text-danger font-error mt-2">
              La transferencia interbancaria es requerida
            </div>
            }
          </div>
        </div>
        } @if
        (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
        ALLOWED_TYPES_FOR_IDENTIFICATION)) {
        <div class="row mt-3">
          <div class="col-sm-6">
            <label>Identificación *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="identificacion"
              required=""
              autocomplete="off"
              [readonly]="isIdentificationMasked"
              [attr.aria-describedby]="isIdentificationMasked ? 'identificacionLockedHint' : null"
              (keyup)="validateField($event, 'identificacion')"
              formControlName="identificacion"
            />
            @if (isIdentificationMasked) {
            <small id="identificacionLockedHint" class="text-muted d-block mt-1">
              <i class="fa-solid fa-lock me-1" aria-hidden="true"></i>
              No tienes permiso para ver ni modificar la identificación.
            </small>
            }
            @if (identificationError) {
            <div class="text-danger font-error mt-2">
              Solo se permite números, letras y guion como caracter especial.
            </div>
            } @if (cwEditForm.controls.identificacion!.touched &&
            cwEditForm.controls.identificacion.errors?.required) {
            <div class="text-danger font-error mt-2">
              La identificacion es requerida
            </div>
            }
          </div>
          <div class="col-sm-6">
            <div class="media align-items-center">
              <label class="col-form-label m-r-10">
                # Cuenta {{ accountTypeLabel }} *
              </label>
              <div class="media-body text-end switch-sm">
                <label class="switch">
                  <input
                    type="checkbox"
                    (change)="toggleAccountType($event)"
                    [checked]="isSaving"
                  />
                  <span class="switch-state"></span>
                </label>
              </div>
            </div>
            <input
              type="text"
              class="form-control custom-input"
              id="numero_cuenta"
              required=""
              formControlName="numero_cuenta"
              (keyup)="validateField($event, 'numero_cuenta')"
            />
            @if (numberAccountError) {
            <div class="text-danger font-error mt-2">
              Solo se permite números, letras y guion como caracter especial.
            </div>
            } @if (cwEditForm.controls.numero_cuenta.touched &&
            cwEditForm.controls.numero_cuenta.errors?.required) {
            <div class="text-danger font-error mt-2">
              El número de cuenta es requerido
            </div>
            }
          </div>
        </div>
        } @if(![TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
        TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT].includes(cwEditForm.get('tipo_transaccion')?.value)){
        @if(this.alloweEnterprise){
        <div class="row mt-3">
          <div class="col-sm-6 mt-1">
            <label>Banco Empresa *</label>
            <ng-select
              [items]="allEnterpriseBankData"
              bindLabel="label"
              bindValue="value"
              formControlName="id_banco_empresa"
              placeholder="Selecciona un banco"
              (scrollToEnd)="onScrollToEnd()"
              (search)="onSearch($event.term)"
              (open)="onSearch('')"
              (clear)="onSearchBank()"
              (change)="isInterbankTransaction ? onBankSelected($event) : null"
            >
            </ng-select>
          </div>
          <div class="col-sm-6">
            <label>Comprobante Empresa *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="comprobante"
              placeholder="Comprobante"
              formControlName="comprobante_empresa"
            />
          </div>
        </div>
        } } @if
        (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
        ALLOWED_TYPES_FOR_BENEFICIARY)) {
        <div class="row mt-3">
          <div class="col-sm-12">
            <label>Beneficiario *</label>
            <input
              type="text"
              class="form-control custom-input"
              formControlName="nombre_titular"
            />
            @if (cwEditForm.controls.nombre_titular!.touched &&
            cwEditForm.controls.nombre_titular.errors?.required) {
            <div class="text-danger font-error mt-2">
              El Beneficiario es requerido
            </div>
            }
          </div>
        </div>
        }
        <div class="row mt-3">
          <div class="col">
            <label
              >Detalle @if
              (isDetailRequired(cwEditForm.get('tipo_transaccion')?.value)) { *
              }</label
            >
            <textarea
              formControlName="detalle"
              rows="3"
              class="form-control"
            ></textarea>
            @if (cwEditForm.controls.detalle.touched &&
            cwEditForm.controls.detalle.errors?.required) {
            <div class="text-danger font-error mt-2">
              El detalle es requerido
            </div>
            }
          </div>
        </div>
        @if (rol !== roles.AGENT) {
        <div class="mt-3">
          <div class="animate-chk">
            <div class="row">
              <div class="col">
                @if
                (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
                ALLOWED_TYPES_FOR_CHECK_RECEIPT)) { @if(isRiskyTicket){
                <label class="d-block" for="chk-ani">
                  <input
                    class="checkbox_animated"
                    id="chk-ani"
                    formControlName="estado_revisar_boleta"
                    type="checkbox"
                    (change)="handleCheckboxChange('estado_revisar_boleta')"
                  />
                  Revisar Boleta (No permite hacer carga directa)
                </label>
                }
                <label class="d-block" for="chk-ani1">
                  <input
                    class="checkbox_animated"
                    id="chk-ani1"
                    formControlName="permitirComprobante"
                    type="checkbox"
                    (change)="handleCheckboxChange('permitirComprobante')"
                  />
                  Permitir Ingresar Comprobante Repetido
                </label>
                } @if
                (isTransactionTypeAllowed(cwEditForm.get('tipo_transaccion')?.value,
                ALLOWED_TYPES_FOR_STATUS_RISKY_RECEIPT)) {
                <label class="d-block" for="chk-ani3">
                  <input
                    class="checkbox_animated"
                    id="chk-ani3"
                    type="checkbox"
                    formControlName="estado_boleta_riesgosa"
                    (change)="handleCheckboxChange('estado_boleta_riesgosa')"
                  />
                  Boleta Riesgosa
                  @if(cwEditForm.get('estado_boleta_riesgosa')?.value) { @if
                  (inappropiatedComment) {
                  <span
                    class="fa fa-question-circle fa-sm text-info"
                    [ngbTooltip]="
                      'Boleta no aceptada: Comentario inapropiado detectado ' +
                      inappropiatedComment +
                      ' ha sido marcada para la devolución'
                    "
                    aria-hidden="true"
                    data-toggle="tooltip"
                    title="Tooltip text"
                  ></span>
                  }@else {
                  <span
                    class="fa fa-question-circle fa-sm text-info"
                    [ngbTooltip]="'Boleta marcada para devolución'"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    title="Tooltip text"
                  ></span>
                  } }
                </label>
                } @if(![TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT,
                TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL].includes(cwEditForm.get('tipo_transaccion')?.value))
                {
                <label class="d-block" for="chk-ani6">
                  <input
                    class="checkbox_animated"
                    id="chk-ani6"
                    formControlName="estado_tiempo_espera"
                    type="checkbox"
                    (change)="handleCheckboxChange('estado_tiempo_espera')"
                  />
                  Transacción en espera
                  @if(cwEditForm.get('estado_tiempo_espera')?.value){
                  <span
                    class="fa fa-question-circle fa-sm text-info"
                    [ngbTooltip]="'La boleta estará en tiempo de espera'"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    tooltipClass="custom-tooltip"
                    title="Tooltip text"
                  ></span>
                  }
                </label>
                }
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      <div class="col-sm-12 col-xl-5 content-right order-1 order-xl-2">
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content-center">
            <div class="media-body text-end switch-sm icon-state">
              <label class="switch">
                <input
                  type="checkbox"
                  [checked]="isManual"
                  (change)="manualSwitch()"
                />
                <span class="switch-state"></span>
              </label>
            </div>
            <label class="col-form-label ms-2 mt-2">Agregar Manualmente</label>
          </div>
          <div class="col-sm-12">
            <span>
              Sube el respectivo <a class="text-emphasis">comprobante</a> para
              completar el proceso.
            </span>
            @if (isRequiredImageMissing()) {
              <div class="text-danger font-error mt-2">
                {{ getRequiredImageMessage() }}
              </div>
            }
            <br />
            <div
              class="drop-area-container mt-3"
              (click)="triggerFileInput()"
              (dragover)="onDragOver($event)"
              (drop)="onDrop($event)"
            >
              <input
                type="file"
                class="file-input"
                required=""
                accept="image/png,image/jpeg"
                (change)="onFileSelected($event)"
                #fileInput
              />
              @if (!previewImage|| isInvalidFileType(previewImage)) {
              <div>
                <i class="fas fa-cloud-upload-alt uploadico"></i>
                <div class="drop-area mt-3 text-center bg-transparent">
                  Arrastra y suelta tu comprobante aquí <br />
                  o sube una
                  <a class="upload-link" (click)="triggerFileInput($event)"
                    ><strong>imagen</strong></a
                  >
                </div>
              </div>
              }@else {
              <div>
                <img
                  [src]="previewImage"
                  alt="Vista Previa"
                  class="cloud-image"
                />
              </div>
              }
              @if (previewImage && isLoadingButton && !isManual) {
                <div class="ocr-reading-overlay">
                  <div class="ocr-reading-content">
                    <img
                      [src]="
                        activeOcrProvider === 'ollama'
                          ? 'assets/images/ocr-providers/Ollama-logo.webp'
                          : 'assets/images/ocr-providers/gemini-logo.svg'
                      "
                      alt="{{ activeOcrProvider === 'ollama' ? 'Ollama' : 'Gemini' }}"
                      class="ocr-provider-logo"
                    />
                    <div class="ocr-reading-title">
                      {{ activeOcrProvider === 'ollama' ? 'Ollama' : 'Gemini' }}
                      está leyendo el comprobante
                    </div>
                    <div class="ocr-reading-subtitle">Espera por favor...</div>
                  </div>
                </div>
              }
            </div>
            @if (isWithdrawalReceiptLocked()) {
            <div class="text-muted mt-2 small text-center">
              {{ WITHDRAWAL_RECEIPT_LOCK.IMAGE_ALREADY_SET_HINT }}
            </div>
            }
            @if (previewImage && !isInvalidFileType(previewImage)) {
            @if (canShowRemoveImageButton()) {
            <div class="mt-2 text-center">
              <button class="secondary-button-sm" (click)="removeImage()">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
            }
            }
          </div>
        </div>
      </div>
    </div>
    <hr class="mt-4 mb-4" />
    <div class="text-end pb-3">
    <div class="text-end">
      <button
        type="button"
        class="primary-button-cancel me-1"
        (click)="closeModal()"
      >
        Cancelar
      </button>
      @if(canPrevalidateRequest() && !isLoadingButton){
      <button
        type="button"
        class="secondary-button me-1"
        (click)="prevalidateRequest()"
        ngbTooltip="Guarda los cambios y pasa la solicitud a Procesado Prevalidado"
        tooltipClass="custom-tooltip"
        [disabled]="
          !(cwData?.tipo_transaccion === 5) &&
          (!cwEditForm.valid ||
            identificationError ||
            numberAccountError ||
            isRequiredImageMissing())
        "
      >
        <i class="fa-solid fa-check-double me-1"></i>
        Prevalidar
      </button>
      }
      @if(isLoadingButton){
      <button class="primary-button" type="submit" disabled>
        <span
          class="spinner-grow spinner-grow-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Loading...
      </button>
      }@else {
      <button
        type="submit"
        class="primary-button"
        [disabled]="
          !(cwData?.tipo_transaccion === 5) &&
          (!cwEditForm.valid ||
            identificationError ||
            numberAccountError ||
            isRequiredImageMissing())
        "
      >
        Editar
      </button>

      }
    </div>
    </div>
  </form>
  }
</div>
